/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Chain_To_Next_EventInputs */



/**
* | output |
* | --- |
* | "Chain To Next Event" |
*
* @param {Shortcut_Keys_Name_Chain_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_chain_to_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Chain_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Chain_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chainer a l'evenement suivant")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung zum nächsten Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Catena al prossimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цепочка к следующему событию")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cadena al siguiente evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("链至下一个事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("次のイベントへのチェーン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अगले इवेंट से जुड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Encadear para o próximo evento")
	return /** @type {LocalizedString} */ ("Chain To Next Event")
});